import { gql } from "@apollo/client";

export const GET_SECTORS = gql`
	query Sectors {
		sectorCollection(order: [priority_DESC]) {
			items {
				sys {
					id
				}
				name
				image {
					url(transform: { width: 800, format: WEBP, quality: 80 })
				}
				slug
			}
		}
	}
`;

export const GET_FEATURED_PROJECTS = gql`
	query Projects($isPreview: Boolean = false) {
		projectCollection(where: { featured: true }, order: [featuredPriority_ASC, sys_firstPublishedAt_DESC], preview: $isPreview) {
			items {
				title
				slug
				sectorCollection(limit: 12) {
					items {
						name
					}
				}
				heroImage {
					url(transform: { width: 1600, format: WEBP, quality: 80 })
				}
				homePageFeatureImage {
					url(transform: { width: 1600, format: WEBP, quality: 80 })
				}
			}
		}
	}
`;
